<div class="row">
  <div class="col-12 offset-lg-2 col-lg-8">

    <div class="row mb-3 delay-header" id="delayHeader">
      <div class="col-12 delay-header__title">
        <h3 *appApplyIfNotEmpty="translationService.getTranslation('delay_intro')"
            [innerHTML]="translationService.getTranslation('delay_intro')"></h3>
      </div>
      <div class="col-12 delay-header__description">
        <p [innerHTML]="translationService.getTranslation('delay_description')"></p>
      </div>
    </div>
    <mat-card class="delay-card mat-mdc-card-outlined">
      <mat-card-content class="delay-card__content">
        <div class="row delay-form">
          <div class="col-12 delay-form__address">
            <app-hup-subscription-address [askForBirthday]="false"
                                          [askForCountry]="false"
                                          [askForEmail]="false"
                                          [showAddressExt1]="false"
                                          [askForPerson]="false"
                                          [controlGroup]="delayForm"
                                          [showActivateCheckbox]="false"></app-hup-subscription-address>
          </div>
          <div class="col-12 delay-form__check-btn">
            <!--zustellung prüfen button-->
            <button ngSkipHydration mat-raised-button color="primary" (click)="checkDelay()" [disabled]="!delayForm.valid"
                    [innerHTML]="translationService.getTranslation('delay_check')" class="delay-form__button"></button>
          </div>
        </div>

        @if (delaystate == DelayComponentEnum.NODELAY) {
          <div class="delay-nodelay">
            <!--  nwenn keine störungsmeldung vorliegt -->
            <div [innerHTML]="translationService.getTranslation('delay_toComplaintForm')"
                 class="row ms-1 mt-3 mb-3 delay-nodelay__info">
            </div>
            <button mat-raised-button color="primary" (click)="navigateToComplaint()"
                    [innerHTML]="translationService.getTranslation('button_new_complaint')"
                    class="delay-nodelay__complaint-btn"></button>
          </div>
        }

        @if (delaystate == DelayComponentEnum.DELAY) {
          <div class="delay-delay">
            <!--  falls Spätmeldung gefunden und weniger Meldungen als Bezirke-->
            <div [innerHTML]="translationService.getTranslation('delay_delay')" class="row mt-3 mb-3 delay-delay__info">
            </div>
            <ul class="delay-delay__list">
              @for (item of messageText; track item) {
                <li class="delay-delay__list-item"> {{ item }}</li>
              }
            </ul>
          </div>
        }

        @if (delaystate == DelayComponentEnum.DELAYINVALIDDISTRICT) {
          <div class="delay-invalid-district">
            <!--  falls bezirk nicht gefunden-->
            <div [innerHTML]="translationService.getTranslation('delay_invalid_district')"
                 class="row mt-3 mb-3 delay-invalid-district__info">
            </div>
            <button mat-raised-button color="primary" (click)="navigateToComplaint()"
                    [innerHTML]="translationService.getTranslation('button_new_complaint')"
                    class="delay-invalid-district__complaint-btn"></button>
          </div>
        }

        @if (delaystate == DelayComponentEnum.POSSIBLEDELAY) {
          <div class="delay-possible">
            <!--Zustellung möglicherweise zu spät, mehr Bezirke als Meldungen-->
            <div [innerHTML]="translationService.getTranslation('delay_possible_delay')"
                 class="row mt-3 mb-3 delay-possible__info">
            </div>
            <ul class="delay-possible__list">
              @for (item of messageText; track item) {
                <li class="delay-possible__list-item"> {{ item }}</li>
              }
            </ul>
          </div>
        }
      </mat-card-content>
    </mat-card>
  </div>
</div>
